/**
 * Vorgabemaße eines frisch abgesetzten Notiz — angelehnt an den
 * Figma-Entwurf „Thought Note" (Node 4869:42429).
 *
 * **Quadratisch und auf dem Punktraster:** 168 = 7 × 24. Das ist keine
 * Kosmetik, daran hängt das Einrasten. Die frühere Größe (160 × 166) traf das
 * Raster nicht (160 / 24 = 6,67) und war nicht quadratisch — beim gemeinsamen
 * Skalieren mehrerer Notizen ließ sich deshalb nie beides zugleich erfüllen,
 * Rastertreue und Seitenverhältnis. Mit 168 geht es auf; auch der Versatz beim
 * Duplizieren landet wieder auf dem Raster (168 + 24 = 192 = 8 × 24).
 *
 * Bewusst hier und nicht je Aufrufer: die Maße stehen in der Datenbank UND
 * werden React Flow als `width`/`height` mitgegeben. Liefen die Stellen
 * auseinander, spränge der Node zwischen Messung und Darstellung.
 *
 * Bestehende Notizen behalten ihre gespeicherte Größe — nur neue kommen
 * quadratisch auf die Welt.
 */
export const DEFAULT_CANVAS_NOTE_WIDTH = 168
export const DEFAULT_CANVAS_NOTE_HEIGHT = 168
